import BookmarkIcon from '../../../../../../../assets/svgs/Bookmark'
import LinkIcon from '../../../../../../../assets/svgs/Link'
import LocationIcon from '../../../../../../../assets/svgs/Location'

import { safeUrl } from '../../../../format'

import style from './style.module.css'

/**
 * The four social tiles this row used to show were decoration: we hold no
 * handles for X, LinkedIn or Facebook.
 *
 * They are replaced by the two links the company registry actually gives us —
 * the company's own website and its Google Maps entry — which are real,
 * verifiable and the two a person researching an employer would click.
 */
const AddToChatBlock = ({ company, onToggleSave }) => {
  const links = [
    { key: 'website', href: safeUrl(company?.website), label: 'Company website', Icon: LinkIcon },
    { key: 'maps', href: safeUrl(company?.mapsUrl), label: 'View on Google Maps', Icon: LocationIcon },
  ].filter((link) => link.href)

  const saved = Boolean(company?.saved)

  return (
    <div className={style.companyModal_addToChat}>
      <div className={style.companyModal_addToChat_socials}>
        {links.map(({ key, href, label, Icon }) => (
          <a
            key={key}
            className={style.companyModal_addToChat_socials_item}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
            data-log-action={`spotlight_open_${key}`}
          >
            <Icon />
          </a>
        ))}
      </div>

      <div className={style.companyModal_addToChat_actions}>
        <button
          type="button"
          className={`${style.companyModal_addToChat_actions_save} ${
            saved ? style.companyModal_addToChat_actions_save_active : ''
          }`}
          onClick={() => onToggleSave?.(company)}
          aria-pressed={saved}
          aria-label={saved ? `Remove ${company?.name} from saved` : `Save ${company?.name}`}
          data-log-action="spotlight_toggle_save"
        >
          <BookmarkIcon />
        </button>
      </div>
    </div>
  )
}

export default AddToChatBlock
